import React from 'react';
// formik
// import {useFormik} from 'formik';
import {makeStyles, createStyles, Theme} from '@mui/material/styles';
// import {Paper, Button, TextField, Snackbar, IconButton} from '@material-ui/core';
// import {Close} from '@material-ui/icons';
// import {ISigninInputValues} from 'lib/types';
// import Alert from '@material-ui/lab/Alert';

// import AuthService from 'services/AuthService';
// cookie
// import cookie from 'js-cookie';
// import CookieService from "config/cookieService"
// import Router from 'next/router';
import {SignInForm} from 'src/components/forms';
// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       flexGrow: 1,
//       padding: '50px',
//     },
//     paper: {
//       padding: theme.spacing(2),
//       margin: 'auto',
//       maxWidth: 425,
//     },
//     input: {
//       width: '100%',
//     },
//     signinBtn: {
//       marginTop: '15px',
//     },
//     label: {
//       fontSize: '14px',
//       color: '#111111',
//     },
//     forgetPassword: {
//       color: '#0091FF',
//       fontSize: '12px',
//       float: 'right',
//     },
//   })
// );

// interface IformikDefination {
//   validateOnChange: boolean;
//   validate?: any;
//   handleSubmit: () => any;
//   handleChange: (data: string) => any;
//   values: ISigninInputValues;
//   errors: any;
//   resetForm: () => void;
// }
function SignIn() {
  // const classes = useStyles();
 
  return (
    <div 
      // className={classes.root}
    >
      <SignInForm />
      
    </div>
  );
}
export default SignIn;
